import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../Layout';
import Post from '../../presentational/Blog/Post';


const post = {
   ordernum: 1, timeStamp: '29.11.2019', postImage: 'https://via.placeholder.com/1200x300', title: 'KVKK ya Hazır mısınız?', subtitle: 'KVKK 31.12.2019 da devreye giriyor', avatarUrl: 'https://via.placeholder.com/250x250', author: 'Azerhan Özen', shortContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc lacinia euismod urna, in gravida leo efficitur a. Sed tempus augue risus, eget faucibus urna hendrerit a. Donec pulvinar maximus dui ut porttitor. Nullam tristique tortor et ipsum tristique, ac lacinia diam faucibus. Nunc cursus massa eget consectetur laoreet ...', likeCount: 32, commentCount: 2,
   author: 'Azerhan Özen',authorTitle: 'ERP Danışmanı',timeStamp: '13.10.2019', shareUrl: 'http://hurriyet.com.tr',
};

const recentPosts = [
  { url: '/BlogPost/12', title: '7 Adımda Maliyet', avatarUrl: 'https://via.placeholder.com/250x250', timeStamp: 'Ekim 2019' },
  { url: '/BlogPost/13', title: 'Yılbaşı geçiş CheckList', avatarUrl: 'https://via.placeholder.com/250x250', timeStamp: 'Eylül 2019' }
];
let comments = [
  {avatarUrl: 'https://via.placeholder.com/250x250', author: 'Tuba Gülle', url: '/BlogPost/12', title: 'ERP de İnsan Faktörü'},
  {avatarUrl: 'https://via.placeholder.com/250x250', author: 'Tuba Gülle', url: '/BlogPost/12', title: 'ERP de İnsan Faktörü'},
  {avatarUrl: 'https://via.placeholder.com/250x250', author: 'Tuba Gülle', url: '/BlogPost/12', title: 'ERP de İnsan Faktörü'}
];
comments = [];

const archieves = [
  { title: 'Ekim 2019', count: 3, url: '/BlogPosts/201910' },
  { title: 'Eylül 2019', count: 13 , url: '/BlogPosts/201909'},
  { title: 'Ağustos 2019', count: 8 , url: '/BlogPosts/201908'},
];

const categories = [
  { title: 'ERP', count: 3, url: '/BlogPosts/erp' },
  { title: 'Mobil', count: 13, url: '/BlogPosts/mobile' },
  { title: 'MES', count: 8, url: '/BlogPosts/mes' },
  { title: 'CRM', count: 12, url: '/BlogPosts/crm' },
  { title: 'HRM', count: 4, url: '/BlogPosts/hrm' }
];

const tags = [
  { title: 'ERP', url: '/BlogPosts/erp' },
  { title: 'Mobil', url: '/BlogPosts/mobile' },
  { title: 'MES', url: '/BlogPosts/mes' },
  { title: 'CRM', url: '/BlogPosts/crm' },
  { title: 'HRM', url: '/BlogPosts/hrm' }
];

const crumbs = [
  { content: 'Blog', url: '/Blog' },
  { content: 'KVKK ya Hazır mısınız?'},
];

const items = [
    { type: 'h5', content: 'Framing is your best friend', style: ''},
    { type: 'p', content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. '},
    { type: 'h5', content: 'Hosting a store can be tricky', style: '' },
    { type: 'p', content: 'Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit. Sed lectus. Integer euismod lacus luctus magna. ' },
    { type: 'h5', content: `Don't neglate product photography`, style: '' },
    { type: 'p', content: 'Cras metus. Sed aliquet risus a tortor. Integer id quam. Morbi mi. Quisque nisl felis, venenatis tristique, dignissim in, ultrices sit amet, augue. Proin sodales libero eget ante. Nulla quam. Aenean laoreet. Vestibulum nisi lectus, commodo ac, facilisis ac, ultricies eu, pede. Ut orci risus, accumsan porttitor, cursus quis, aliquet eget, justo. Sed pretium blandit orci. Ut eu diam at pede suscipit sodales. Aenean lectus elit, fermentum non, convallis id, sagittis at, neque.'},
    { type: 'img', style: 'post-image', url: 'https://via.placeholder.com/1954x1178', alt: ''},
    { type: 'h5', content: 'Customer conversion is the key', style: '' },
    { type: 'p', content: 'Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit. Sed lectus. Integer euismod lacus luctus magna. ' },
    { type: 'h5', content: 'Implement an abandonned cart workflow', style: '' },
    { type: 'p', content: 'Cras metus. Sed aliquet risus a tortor. Integer id quam. Morbi mi. Quisque nisl felis, venenatis tristique, dignissim in, ultrices sit amet, augue. Proin sodales libero eget ante. Nulla quam. Aenean laoreet. Vestibulum nisi lectus, commodo ac, facilisis ac, ultricies eu, pede. Ut orci risus, accumsan porttitor, cursus quis, aliquet eget, justo. Sed pretium blandit orci. Ut eu diam at pede suscipit sodales. Aenean lectus elit, fermentum non, convallis id, sagittis at, neque.' },
    { type: 'hr' },
];

export default class Contact extends Component {
  render() {
    return(
      <Layout>
       <Post
         post={post}
         recentPosts={recentPosts}
         comments={comments}
         archieves={archieves}
         categories={categories}
         tags={tags}
         crumbs={crumbs}
         items={items}
        />
      </Layout>
    );
  }
};
